import { BaseOauthClient } from "./base";

export class XeroOauthClient extends BaseOauthClient {
    provider = "xero";
    baseUrl = "https://login.xero.com";
    authorizationEndpoint = '/identity/connect/authorize';
    tokenEndpoint = "https://identity.xero.com/connect/token";
    // authenticationMethod = "client_secret_post";

    clientId = process.env.XERO_CLIENT_ID || "";
    clientSecret = process.env.XERO_CLIENT_SECRET || "";
    scopes = [
        "accounting.attachments.read",
        "accounting.budgets.read",
        "accounting.contacts.read",
        "accounting.journals.read",
        "accounting.reports.read",
        "accounting.reports.tenninetynine.read",
        "accounting.settings.read",
        "accounting.transactions.read",
        "assets.read",
        "offline_access",
    ];

    constructor(team: string, supabaseClient: any, id?: string) {
        super(team, supabaseClient, id);
        this.initializeOauthClient();

        this.actions = {
            "getConnections": async (params: any) => {
                let output = await this.fetcher.fetch("https://api.xero.com/connections").then(a => a.json());
                let bases = output.map((a: any) => ({ value: a.tenantId, label: a.tenantName })) as { label: string, value: string }[];
                return bases
            }
        }
    }

    async getRecords() {
        return [];
    }
}

